import { Text, Typeahead } from "@merge-api/merge-javascript-shared";
import { SyntheticEvent, MouseEvent, KeyboardEvent, FocusEvent } from "react";

interface CommonModelTypeaheadProps {
  modelNames: string[];
  selectedFields: string[];
  onChange: (models: string[]) => void;
}

const renderOption = (option: string) => {
  return <Text>{option}</Text>;
};

const CommonModelTypeahead = ({
  modelNames,
  selectedFields,
  onChange,
}: CommonModelTypeaheadProps) => {
  // Const derived from props
  const options = [...(modelNames || [])];

  // Handler to update selected options
  const handleTypeaheadChange = (
    _event:
      | SyntheticEvent<Element, Event>
      | MouseEvent<Element, MouseEvent>
      | KeyboardEvent<Element>
      | FocusEvent<Element>
      | null,
    newSelectedOptions: string[] | null
  ) => {
    const newSelection = newSelectedOptions || [];
    onChange(newSelection);
  };

  return (
    <div>
      <Text as="div" variant="h6" className="mb-2">
        Select Common Models
      </Text>
      <Typeahead
        multiple
        onChange={handleTypeaheadChange}
        options={options}
        value={selectedFields}
        renderOption={renderOption}
        disableCloseOnSelect
        placeholder="All models"
        tagsLimit={4}
      />
    </div>
  );
};

export default CommonModelTypeahead;
